'use strict';

import {TeejitRestClient} from '../services/teejit-rest-client.js';

class TeejitMarkedContentLoader {
    constructor(config = {}) {
        this.config = config;
        this.restClient = new TeejitRestClient({
            restBaseUrl: config.restBaseUrl,
            accessToken: config.accessToken,
            nonce: config.nonce,
        });
        this.endpoint = String(config.endpoint || 'theme/user/marked-content').replace(/^\/+/, '');
        this.spinnerId = String(config.spinnerId || 'user-load-spinner-marked-content');
        this.targetSelector = String(config.targetSelector || 'div.user-marked-content');
    }

    static boot() {
        const configEl = document.getElementById('kh-marked-content-config');
        if (!configEl || window.khMarkedContentLoader) {
            return null;
        }

        let config = {};
        try {
            config = JSON.parse(configEl.textContent || '{}');
        } catch (error) {
            config = {};
        }

        window.khMarkedContentLoader = new TeejitMarkedContentLoader(config);
        window.khMarkedContentLoader.load();
        return window.khMarkedContentLoader;
    }

    async load() {
        const target = document.querySelector(this.targetSelector);
        if (!target) {
            this.removeSpinner();
            return;
        }

        try {
            const html = await this.restClient.requestHtml(this.endpoint);
            this.removeSpinner();
            if (html && html.length > 0) {
                target.innerHTML = html;
            }
        } catch (error) {
            this.removeSpinner();
            this.notifyLoadError();
        }
    }

    removeSpinner() {
        const spinner = document.getElementById(this.spinnerId);
        if (spinner) {
            spinner.remove();
        }
    }

    notifyLoadError() {
        const message = window.khThemeRuntime?.teamContentFilter?.loadError || 'Content could not be loaded. Please try again later.';
        if (window.AWN) {
            const notifier = window.KHNotifications?.createNotifier({
                labels: {alert: window.khThemeRuntime?.messages?.noticeContent || 'Content'}
            }) || new window.AWN({labels: {alert: 'Content'}});
            notifier.alert(message, {durations: {global: 5000}});
            return;
        }
        if (window.khThemeRuntime?.debugAjax) {
            console.error(message);
        }
    }
}

if (typeof window !== 'undefined') {
    window.TeejitMarkedContentLoader = TeejitMarkedContentLoader;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => TeejitMarkedContentLoader.boot());
    } else {
        TeejitMarkedContentLoader.boot();
    }
}

export {TeejitMarkedContentLoader};
